export const AppSettings = {
  baseUrl: process.env.REACT_APP_BACKEND_URL,
  mockUrl: process.env.REACT_APP_BACKEND_MOCK_URL,
  rollbarToken: process.env.REACT_APP_ROLLBAR_TOKEN,
  env: process.env.REACT_APP_ENV,
  isLocal: process.env.REACT_APP_ENV === 'local',
};
